import { render, staticRenderFns } from "./NotificationAddObservationDoc.vue?vue&type=template&id=5c2093e2"
import script from "./NotificationAddObservationDoc.vue?vue&type=script&lang=js"
export * from "./NotificationAddObservationDoc.vue?vue&type=script&lang=js"
import style0 from "./NotificationAddObservationDoc.vue?vue&type=style&index=0&id=5c2093e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports